import React from 'react'
import { ComponentData } from '../data/ComponentContext'
import Flach from '../img/flach.png'
import Hinterschnitt from '../img/hinterschnitt.png'
import { Col, Row } from 'react-bootstrap'


function GeometryRadio({ className, displayErrors }) {

  const { Geometry, selectedGeometry, setSelectedGeometry, geometryIsValid } = ComponentData()

  return (
    <Col md={12}>
      <div className={className}>
        <Row>
          {Geometry.map((geo) => {
            return (
              <Col md={6} key={"radio- " + geo}>
                <label className={displayErrors && !geometryIsValid ? 'error' : ''}>
                  <input
                    type="radio"
                    name='geometry'
                    checked={selectedGeometry === geo}
                    onChange={(e) => { setSelectedGeometry(e.target.value) }}
                    className={'radio-geometry ' + geo}
                    value={geo}
                  />
                  <div>
                    <span className='geo-label'>{geo}</span>
                    <img className='geo-img' src={geo === 'Flach' ? Flach : Hinterschnitt} alt='' />
                  </div>

                </label></Col>
            )
          })}
          {displayErrors && !geometryIsValid ? <p className="error">Geometrie muss ausgewählt werden!</p> : null}
        </Row>
      </div>
    </Col>
  )
}

export default GeometryRadio